<template>
  <div class="c-tags-wrapper">
    <!-- filter -->
    <tags-filter
      slot="filter"
      :asyning="asyning"
      :label-types="labelTypes"
      @on-down="downData"
      @on-refresh="refreshData"
      @on-change="filterData"
    />

    <!-- table  -->
    <div class="c-table-list">
      <Viewport v-model="tableHeight">
        <el-table
          class="summary-el-table-styles common-el-table-styles"
          stripe
          border
          show-summary
          v-loading="loading"
          :data="tableData"
          :height="tableHeight"
          :summary-method="summary"
        >
          <el-table-column
            v-for="(col, id) in tableColumns"
            :key="id"
            :prop="col.key"
            :label="col.title"
            :show-overflow-tooltip="col.overflow"
            :min-width="col.width"
            :align="col.align"
          >
            <template slot-scope="scope">
              <span v-if="col.key === 'consumePercent'">{{ scope.row[col.key] | toPercent }}</span>
              <span v-else-if="col.key === 'amount'">{{ scope.row[col.key] | toThousands }}</span>
              <span v-else>{{ scope.row[col.key] }}</span>
            </template>
          </el-table-column>
          <template slot="empty">
            <no-data />
          </template>
        </el-table>

        <Page
          show-total
          show-sizer
          show-elevator
          class="c-table-page pager"
          size="small"
          :total="total"
          :current.sync="pageIndex"
          :page-size="pageSize"
          :page-size-opts="[10, 20, 30, 40, 100]"
          @on-change="changePageIndex"
          @on-page-size-change="changePageSize"
        />
      </Viewport>
    </div>
  </div>
</template>
<script>
import { isArray } from '@/common/js/utils'
import { HOST_API } from '@/api/config'
import { toThousands } from '@/common/js/filters'
import TagsFilter from './components/tags-filter.vue'
import tableMixin from './table-mixin'
import tableColumns from '../data/tag_columns'

import { asynPlannerPage } from '@/api/team.model'
import { getImageLabelPage } from '@/api/report.model'
import { getSysTag } from '@/api/common.model'
import { LABEL_TYPES } from '@/views/material/tags/const'

export default {
  name: 'reportTags',
  mixins: [tableMixin],
  components: { TagsFilter },
  data() {
    return {
      asyning: null,
      loading: null,
      tableHeight: 330,
      tableData: [],
      tableColumns: [],
      sumData: [],
      labelTypes: [] // 营销主题标签
    }
  },
  methods: {
    refreshData() {
      this.asyning = true
      asynPlannerPage({
        dateType: this.params.dateType,
        beginTime: this.params.beginTime
      })
        .then((data) => {
          this.asyning = false
          data && this.getData()
        })
        .catch(() => {
          this.asyning = false
        })
    },
    downData() {
      let url = `${HOST_API}/api/ptom/designer/downTypeLabelReport`
      url += `?sessionid=${this.$store.state.token}`
      url += `&dateType=${this.params.dateType}`
      url += `&beginTime=${this.params.beginTime}`
      this.params.labelIdsStr && (url += `&labelIdsStr=${this.params.labelIdsStr}`)
      this.params.order && (url += `&order=${this.params.order}`)
      this.params.sort && (url += `&sort=${this.params.sort}`)
      window.open(url)
    },
    summary(param) {
      const { columns } = param
      const data = this.sumData
      const sums = []
      columns.forEach((column, index) => {
        const prop = column.property
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        sums[index] = toThousands(data[prop])
      })
      return sums
    },
    getData(filter) {
      let params = {
        pageId: this.pageIndex,
        pageSize: this.pageSize
      }
      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)
      this.params = JSON.parse(JSON.stringify(params))
      this.loading = true
      getImageLabelPage(params)
        .then((data) => {
          if (typeof data !== 'symbol') this.loading = false
          if (!data) return
          const { list, page_info, sum_data } = data
          if (isArray(list) && page_info) {
            const { total_number } = page_info
            this.tableColumns = tableColumns
            this.tableData = list
            this.sumData = sum_data
            this.total = total_number || 0
          } else {
            this.tableColumns = []
            this.tableData = []
            this.sumData = []
            this.total = 0
          }
        })
        .catch(() => {
          this.loading = false
          this.tableData = []
          this.sumData = []
          this.tableColumns = []
          this.total = 0
        })
    },
    preloadData() {
      Promise.all([getSysTag({ labelType: LABEL_TYPES.MARKETING_LABEL })]).then((data) => {
        const [labelTypes] = data
        if (isArray(labelTypes)) {
          this.labelTypes = labelTypes.map((ret) => {
            return {
              id: ret.labelId,
              name: ret.content
            }
          })
        }
      })
    }
  },
  created() {
    this.preloadData()
  }
}
</script>
<style lang="scss" scoped>
.c-tags-wrapper {
  position: relative;
  height: 100%;

  .c-table-page {
    padding: 5px 0;
    text-align: right;
  }
}
</style>
